import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery } from '../../styles';
import { Heading } from './Heading';
import { HtmlContent } from './HtmlContent';

const StyledSectionHeader = styled.header`
  margin: 0 auto;
  max-width: 800px;
  text-align: center;
`;

const StyledText = styled(HtmlContent)`
  margin-top: 14px;

  ${minBreakpointQuery.small`
    margin-top: 18px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 22px;
  `}
`;

export const SectionHeader = ({ heading, text, ...props }) => (
  <StyledSectionHeader {...props}>
    <Heading>{heading}</Heading>
    <StyledText content={text} />
  </StyledSectionHeader>
);
